import React from "react";
import Tabs from "@mui/material/Tabs";
import Tab, { TabTypeMap } from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Button,
  ExtendButtonBase,
  ExtendButtonBaseTypeMap,
  Typography,
} from "@mui/material";

export default function NotifTabbar() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box
      sx={{
        bgcolor: "background.paper",
        width: "100%",
        // border: "1px solid gray",
        "& .MuiTabs-root": {
          minWidth: "100%",
          flexDirection: "row-reverse",
          opacity: 1,
        },
        "& .MuiButtonBase-root": {
          width: "fit-content",
          paddingX: "6px",
        },
      }}
    >
      <Tabs
        style={{
          direction: "rtl",
          display: "flex",

          // border: "1px solid gray",
        }}
        sx={{
          "& .MuiTabs-root": {
            minWidth: "100% !important",
            direction: "ltr",
            // minHeight: "fit-content !important",
          },
        }}
        scrollButtons={false}
        value={value}
        onChange={handleChange}
        variant="scrollable"
        allowScrollButtonsMobile
        aria-label="scrollable force tabs example"
      >
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={0}
          label="همه "
        />
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={1}
          label="کارن‌کلاب"
        />
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={2}
          label="اطلاعیه"
        />
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={3}
          label="اطلاعیه"
        />
        <CustomTab
          handleChangeTab={(index) => setValue(index)}
          index={4}
          label="اطلاعیه"
        />
      </Tabs>
    </Box>
  );
}

interface ICustomTab {
  label: string;
  index: number;
  handleChangeTab: (index: number) => void;
}

function CustomTab({ label, index, handleChangeTab, ...rest }: ICustomTab) {
  return (
    <Button
      onClick={() => handleChangeTab(index)}
      sx={{
        borderRadius: "0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        paddingBottom: "10px",
        paddingTop: "10px",
        // border: "1px solid gray",
        minWidth: "100px",
        // textAlign: "center",
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          color: "primary.main",
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          flexShrink: 0,
          width: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          // border: "1px solid gray",
          borderRadius: "50%",
          backgroundColor: "primary.main",
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            color: "background.default",
          }}
        >
          1
        </Typography>
      </Box>
    </Button>
  );
}
